import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/ValidationX.svg'

export const IconValidationX = IconSVG as IconComponent
